import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const Store_URL = `${API_URL}/delivery-instructions`;

const ListDeliveryInstructions = () => {
  return axios.get(`${Store_URL}/list`).then(
      (response) => response 
    )
    .catch((error) => {
      console.error("Error fetching data:", error);
      throw error;
    });
};

const createDeliveryInstructions = (formData: FormData) => {
  return axios
    .post(`${Store_URL}/add`, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Set Content-Type header to multipart/form-data
      },
    })
    .then((response) => response.data);
};

const deleteDeliveryInstructionsById = (id: any, userId: any) => {
  return axios.put(`${Store_URL}/delete/${id}`, { userId }).then((response) => {
    return response.data;
  });
};

const updateDeliveryInstructions = (formData: FormData, id: any) => {
  return axios
    .put(`${Store_URL}/edit/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Set Content-Type header to multipart/form-data
      },
    })
    .then((response) => {
      return response.data;
    });
};

export { ListDeliveryInstructions, createDeliveryInstructions, deleteDeliveryInstructionsById, updateDeliveryInstructions };
